var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLdap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55664 24.5V15.7727H6.61346V23.5625H10.6703V24.5H5.55664Z",
    fill: "#0B1641"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 24.5H12.3066V15.7727H15.1191C15.9657 15.7727 16.6902 15.9474 17.2924 16.2969C17.8947 16.6434 18.3564 17.142 18.6774 17.7926C18.9984 18.4403 19.1589 19.2159 19.1589 20.1193C19.1589 21.0284 18.997 21.8111 18.6731 22.4673C18.3493 23.1207 17.8777 23.6236 17.2583 23.9758C16.639 24.3253 15.8862 24.5 14.9998 24.5ZM13.3635 23.5625H14.9316C15.6532 23.5625 16.2512 23.4233 16.7257 23.1449C17.2001 22.8665 17.5538 22.4701 17.7868 21.9559C18.0197 21.4417 18.1362 20.8295 18.1362 20.1193C18.1362 19.4148 18.0211 18.8082 17.791 18.2997C17.5609 17.7883 17.2172 17.3963 16.7598 17.1236C16.3024 16.848 15.7328 16.7102 15.051 16.7102H13.3635V23.5625Z",
    fill: "#0B1641"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8794 24.5H19.7715L22.976 15.7727H24.0669L27.2715 24.5H26.1635L23.5556 17.1534H23.4874L20.8794 24.5ZM21.2885 21.0909H25.7544V22.0284H21.2885V21.0909Z",
    fill: "#0B1641"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6309 24.5V15.7727H31.5797C32.2644 15.7727 32.824 15.8963 33.2587 16.1434C33.6962 16.3878 34.0201 16.7187 34.2303 17.1363C34.4405 17.554 34.5456 18.0199 34.5456 18.5341C34.5456 19.0483 34.4405 19.5156 34.2303 19.9361C34.0229 20.3565 33.7019 20.6917 33.2672 20.9417C32.8326 21.1889 32.2757 21.3125 31.5968 21.3125H29.4831V20.375H31.5627C32.0314 20.375 32.4078 20.294 32.6919 20.1321C32.976 19.9701 33.182 19.7514 33.3098 19.4758C33.4405 19.1974 33.5059 18.8835 33.5059 18.5341C33.5059 18.1846 33.4405 17.8721 33.3098 17.5966C33.182 17.321 32.9746 17.1051 32.6877 16.9488C32.4007 16.7898 32.0201 16.7102 31.5456 16.7102H29.6877V24.5H28.6309Z",
    fill: "#0B1641"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLdap);
export default __webpack_public_path__ + "static/media/Ldap.a224018c1088c9ffafa2bd25f36306db.svg";
export { ForwardRef as ReactComponent };